import { api } from '@/modules/shared/lib/axios'

export function fetchReports() {
  async function loadSalesGoal(month: string, year: string, vendedor?: string) {
    return await api.get(`vendas/${month}/${year}`, { headers: vendedor ? { vendedor } : undefined })
  }

  async function loadSalesByClient(dateStart: string, dateEnd: string, vendedor?: string) {
    return await api.get(`vendasporcliente/${dateStart}/${dateEnd}`, { headers: vendedor ? { vendedor } : undefined })
  }

  async function loadSalesByProduct(dateStart: string, dateEnd: string, vendedor?: string) {
    return await api.get(`vendasporproduto/${dateStart}/${dateEnd}`, { headers: vendedor ? { vendedor } : undefined })
  }

  async function loadSalesCommission(dateStart: string, dateEnd: string, vendedor?: string) {
    return await api.get(`comissao/${dateStart}/${dateEnd}`, { headers: vendedor ? { vendedor } : undefined })
  }

  return {
    loadSalesGoal,
    loadSalesByClient,
    loadSalesByProduct,
    loadSalesCommission,
  }
}
